var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-list-group',_vm._l((_vm.items),function(item){return _c('b-list-group-item',{key:item.SZ.uid,attrs:{"href":"#","variant":"primary","active":item.Active},on:{"click":function($event){return _vm.itemClick(item.SZ.uid)}}},[_vm._v(_vm._s(item.SZ.name))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }